// extracted by mini-css-extract-plugin
export var displayNone = "_ru-6";
export var imgContainer = "_ru-2";
export var overflowHidden = "_ru-3";
export var productInfoCardButtonContainer = "_ru-5";
export var productTitleText = "_ru-4";
export var rightArrow = "_ru-1";
export var rightArrowContainer = "_ru-0";